import React, {Component} from 'react';
import {TYPE_MAP,TYPE_MAP_VIEW,WELL_CHOSEN_MAP} from '../../../utils/questionType';
import {Rate,Tooltip} from 'antd';
import {ONLINESTATUS} from '../../../utils/questionManageType';
import Footer from '../exercise/Footer';

const $ = require('$');
const MathQuill = require('MathQuill');

const MQ = MathQuill.getInterface(2);

class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }
    toggleAnswer = (val, e) => {
        // val && cnzz.statistics('PC端作业详情页', 2, '展开答案'); /** 打点统计 */
        e.stopPropagation();
        this.setState({visible: val});
    };
    componentDidMount() {
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            })
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
        if(this.props.data.subject==='0'){
            this.setState({visible:true})  //数学题默认答案显示
        }
    }


    componentDidUpdate() {
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
    }

    createHtml = str => ({__html: str ? str : `&nbsp;`});


    render() {
        const {visible} = this.state;
        let originData = this.props.data;
        if(this.props.errorAnswer){originData.answer = this.props.errorAnswer}//题目检错页显示的是错的的答题答案

        const {num, children} = this.props;
        let data = originData;
        let stem = JSON.parse(data.stem)
        return (
            <div className="box-exercise" ref={'viewer'}>
                <div className="exercise-content">
                    {num!=='undefined'&&<div className="exercise-num"><p className="math_text">{`${num + 1}、`}</p></div>}
                    {/*<div className="exercise-con" dangerouslySetInnerHTML={this.createHtml(data.stem)}/>*/}
                    <div className="exercise-con" >
                        <div>
                            单词：{
                                stem.text.split('').map((d,i)=>
                                    <span key={i} style={{color:stem.main_phonics_position.some(d=>d==(i+1))?'red':''}}>{d}</span>
                                )
                            }
                        </div>
                        <div>
                            图片：
                            <div style={{textAlign:'center',position:'relative',overflow:'hidden',minHeight:120}}>
                                <div style={{position:'absolute',left:'0',border:'solid 1px #999',padding:'10px'}}>
                                    <div className={'video_cover_img_preview'} style={{textAlign:'left',position:'relative',width:120,maxHeight:90}}>
                                        {
                                            stem.image_url&&
                                            <img src={stem.image_url} width={120}  style={{maxHeight:70}} controls="controls"/>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            音频：
                            <div style={{textAlign:'center',position:'relative',overflow:'hidden',minHeight:70}}>
                                <div style={{position:'absolute',left:'0',padding:'10px'}}>
                                    <div className={'video_cover_img_preview'} style={{textAlign:'left',position:'relative',width:160,minHeight:120}}>
                                        {
                                            stem.audio_url&&
                                            <audio  src={stem.audio_url} controls="controls">您的浏览器不支持</audio>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div style={{marginBottom:10}}>
                                音素：
                            </div>

                            {

                                stem.phonics_list&&stem.phonics_list.length&&
                                stem.phonics_list.map((item, key) =>{
                                        return <div key={key} style={{marginBottom:20}}>
                                            <div style={{display:'inline-block', width:50,fontSize:14,color:'#999'}}>
                                                音素{key+1}:
                                            </div>

                                            <div style={{fontSize:14,display:'inline-block'}}>
                                                <div style={{display:'inline-block', width:100,marginBottom:10}}>
                                                    字母：{item.text}
                                                </div>
                                                <div style={{display:'inline-block', width:150,marginBottom:10}}>
                                                    位置：{item.position && item.position.join(',')}
                                                </div>
                                                <div style={{display:'inline-block',marginLeft:20, width:200,verticalAlign:'-webkit-baseline-middle' }}>
                                                    <audio  src={item.audio_url} controls="controls">您的浏览器不支持</audio>
                                                </div>

                                            </div>
                                        </div>
                                    }

                                )

                            }
                        </div>
                    </div>

                </div>
                <div className="exercise-footer">
                    {
                        visible &&
                        <div className="footer-hide relative">
                            <div>
                                <div className="inline-block"><span style={{fontSize: 14}}>{this.props.errorAnswer?'错误答案：':'正确答案：'}</span></div>
                                <div className="inline-block" style={{width: '80%'}}>
                                    <span style={{fontSize: 14}} dangerouslySetInnerHTML={this.createHtml(data.answer)}/>
                                </div>
                            </div>
                            {
                                data.explain && <div>
                                    <div className="inline-block"><span style={{fontSize: 14}}>答案解析：</span></div>
                                    <div className="inline-block">
                                        <span style={{fontSize: 14}} dangerouslySetInnerHTML={this.createHtml(data.explain)}/>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                            {
                                this.props.canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={(e) => this.toggleAnswer(!visible,e)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }

                        </Footer>
                    </div>
                </div>
            </div>


        )
    }
}


export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/naturefollow/viewForView.js